import * as React from "react";
import logo from "../intrinsic_logo.svg";
import LocalOfferRoundedIcon from "@mui/icons-material/LocalOfferRounded";
import { Button, ButtonGroup, Box } from "@mui/material";

export default function DistrictHeader(props) {
  return (
    <header className="App-header" style={{ backgroundColor: "white" }}>
      <img src={logo} className="App-logo" alt="logo" />
      <span style={{ marginRight: "0.3em", color: "darkgray" }}>
        EPIC {props.language === "english" ? "Store" : "Tienda"}
        <LocalOfferRoundedIcon
          style={{ verticalAlign: "middle", margin: "10px" }}
          color="warning"
          fontSize="large"
        />
        {true? null : (
          <Button variant="contained" onClick={() => props.changeLanguage()}>
            {props.language === "english" ? "Tienda" : "Store"}
          </Button>
        )}
      </span>
      <ButtonGroup>
        <Button
          color="info"
          target="_blank"
          href="https://sites.google.com/intrinsicschools.org/belmont-epic-store"
        >
          Belmont Info
        </Button>
        <Button
          color="info"
          target="_blank"
          href="https://sites.google.com/intrinsicschools.org/downtown-epic-store"
        >
          Downtown Info
        </Button>
      </ButtonGroup>
      <Box m={2}/>
    </header>
  );
}
